import React from 'react'

import { FlowRoute } from 'utils/FlowProvider/types'

export const LATER_HERO_COPY = new Map([
  [
    FlowRoute.Signup,
    {
      header: 'Create account',
      text: (
        <>
          Start saving today for a better tomorrow with Acorns Later, an easy way to save for
          retirement. <strong>Just $2 per month.</strong>
        </>
      ),
    },
  ],
  [
    FlowRoute.Funding,
    {
      header: 'Link your bank',
      text:
        'Link your primary checking account so you can save for the life you want later just by going about your day.',
    },
  ],
  [
    FlowRoute.Institutions,
    {
      header: 'First, find your bank',
      text: 'Select your bank from the list below and log into your account.',
      footnote: 'Protected by bank-level security',
      footnoteLock: true,
    },
  ],
  [
    FlowRoute.ManualFundingSource,
    {
      header: 'Link your bank account',
      text:
        'We need a little more information to link your bank account, so you can fund your investments.',
      footnote: 'Your data is protected with 256-bit encryption',
      footnoteLock: true,
    },
  ],
  [
    FlowRoute.PersonalInfo,
    {
      header: 'About you',
      text: 'We’ll use this information to secure your account and keep your money safe.',
    },
  ],
  [
    FlowRoute.SuitabilityQuestions,
    {
      header: 'Your finances and goals',
      text:
        'Tell us a little about your current financial situation so we can recommend the best investment portfolio for you.',
    },
  ],
  [
    FlowRoute.ContactInfo,
    {
      header: 'About you',
      text: 'We’ll use this information to secure your account and keep your money safe.',
    },
  ],
  [
    FlowRoute.InvestorQuestions,
    {
      header: 'For legal purposes',
      text: 'These don’t apply to most people but, if they apply to you, let us know.',
    },
  ],
  [
    FlowRoute.OneTimeInvestment,
    {
      header: 'Start small',
      text:
        'You don’t need thousands of dollars to start investing. Make one investment of as little as $5 and then add more when you’re ready.',
    },
  ],
  [
    FlowRoute.RecurringInvestment,
    {
      header: 'Invest in Acorns Later',
      text:
        'Maximize your earnings potential by setting a recurring investment that works for you.',
    },
  ],
  [
    FlowRoute.BankLinkSuccess,
    {
      header: 'You’re all linked up',
      text: 'Your bank account is linked to Acorns and you’re ready to start saving for later.',
    },
  ],
  [
    FlowRoute.Welcome,
    {
      header: 'Later made easier',
      text: (
        <>
          Start saving for a better future with both Acorns Later and Acorns Invest for just{' '}
          <strong>$2 per month.</strong>
        </>
      ),
    },
  ],
  [
    FlowRoute.RoundUpsInterstitial,
    {
      header: 'Round-Ups® are on',
      text:
        "Every time you buy something, like gas or coffee, we'll round the purchase up to the next dollar and invest it for you. Just link your debit or credit cards and we’ll take it from there.",
      disclaimer: 'You can turn Round-Ups® off in settings at anytime',
      ctaLabel: 'Continue',
    },
  ],
])
